import { useCurrency, CURRENCIES } from "@/context/CurrencyContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DollarSign, IndianRupee, ChevronDown } from "lucide-react";

export default function CurrencySwitcher({ className = "" }) {
  const { currency, setCurrency, currencyConfig } = useCurrency();

  const icons = {
    USD: DollarSign,
    INR: IndianRupee
  };

  const CurrentIcon = icons[currency] || DollarSign;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`rounded-full gap-1 h-8 px-3 ${className}`}
        >
          <CurrentIcon className="w-4 h-4" />
          <span className="font-medium">{currency}</span>
          <ChevronDown className="w-3 h-3 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {Object.entries(CURRENCIES).map(([code, config]) => {
          const Icon = icons[code] || DollarSign;
          return (
            <DropdownMenuItem
              key={code}
              onClick={() => setCurrency(code)}
              className={`cursor-pointer ${currency === code ? 'bg-[#F7FFE5]' : ''}`}
            >
              <Icon className="w-4 h-4 mr-2" />
              <span className="flex-1">{config.name}</span>
              {currency === code && (
                <span className="text-[#BFFF00] font-bold">✓</span>
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
